<template>
  <div>
    <UnableToOfferHeader class="px-10 m:px-0"/>
    <!-- <div class="curved-bg">
      <div class="curved"></div>
    </div>
    <div class="curved-container container max-w-5xl mx-auto px-4">
      <div class="shadow-full-short mt-2 p-8 rounded-lg"> -->
        <!-- <div class="text-center px-2 md:px-20 pb-10">
            <div class="mb-8">
              <CreditWiseLogo class="w-2/4 md:w-1/4 inline-block" />
            </div>
            <div class="mb-8">
              <h2 class="text-5xl text-center leading-none font-semibold mb-4">Get to know your credit score</h2>
            </div>
            <div class="mb-8">
              <p class="text-xl leading-tight text-center font-medium">CreditWise is an easy way to check your credit score and report to help you improve your chances of acceptance in the future.</p>
            </div>
            <div>
              <ul class="mx-auto w-5/6">
                  <li class="flex items-center mb-6">
                    <div class="rounded-full border p-2 fill-current text-polred">
                      <TickIcon class="w-6 h-6 align-middle" />
                    </div>
                <span class="text-gray-700 text-lg ml-3 text-left">100% free credit score – No trial period and no card details needed, now or ever.</span>
              </li>
              <li class="flex items-center mb-6">
                  <div class="rounded-full border p-2 fill-current text-polred">
                    <TickIcon class="w-6 h-6 align-middle" />
                  </div>
                  <span class="text-gray-700 text-lg ml-3 text-left">Won't hurt your credit score – Register and sign in as often as you like.</span>
              </li>
              <li class="flex items-center mb-6">
                  <div class="rounded-full border p-2 fill-current text-polred">
                    <TickIcon class="w-6 h-6 align-middle" />
                  </div>
                  <span class="text-gray-700 text-lg ml-3 text-left">Find out how to improve – Bite-size tips help you know what steps to take.</span>
              </li>
              </ul>
            </div>
            <div class="flex justify-center">
            <a :href="capitalOneUrl">
              <button type="button" class="text-xl px-10 w-full hover:bg-polred-dark shadow bg-polred focus:shadow-outline focus:outline-none text-white font-semibold py-2 px-4 rounded-full">
                CreditWise <RightArrowIcon class="h-4 fill-current inline"/>
              </button>
            </a>
        </div> -->
          <!-- </div>
      </div>
    </div> -->
    <Footer/>
  </div>
</template>

<script>

 // import CreditWiseLogo from '@/v2/assets/images/logos/credit-wise.svg'
 // import TickIcon from '@/v2/assets/images/icons/select-tick.svg'
import Footer from '@/v2/components/Footer'
 // import RightArrowIcon from '@/v2/assets/images/icons/right-arrow.svg'
import UnableToOfferHeader from '@/v2/components/headers/UnableToOfferHeader'

import '@/v2/assets/css/app.css'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'UnableToOffer',
  components: {
    // TickIcon,
    // RightArrowIcon,
    UnableToOfferHeader,
    // CreditWiseLogo,
    Footer
  },
  created () {

  },
  computed : {
    
  },
  data() {
    return {
      capitalOneUrl: process.env.VUE_APP_CREDITWISE_URL
    }
  },
  methods: {
    
  }
}
</script>

<style>

</style>
